<div class="pdq-item">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
    <h2>PDQm</h2>
  </div>
  <div class="source">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <div fxLayout="column">Source </div>
      <div fxLayout="column">
        <input nz-input type="text" [(ngModel)]="ip" />
      </div>
      <div fxLayout="column">:</div>
      <div fxLayout="column" fxFlex="70px">
        <input nz-input type="number" [(ngModel)]="port" />
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="margin-top: 10px">
      <div fxLayout="column">Format: </div>
      <nz-switch [(ngModel)]="isXmlFormat" [nzCheckedChildren]="'XML'" [nzUnCheckedChildren]="'JSON'"></nz-switch>

    </div>

    <div fxLayout="row wrap" fxLayoutGap="10px" fxLayoutAlign="start start" style="margin-top: 15px">
      <div fxFlex="49" fxLayout="column">
        <label>Family Name:</label>
        <input nz-input [(ngModel)]="searchParams.family" />

        <label>Given Name:</label>
        <input nz-input [(ngModel)]="searchParams.given" />

        <label>Birthdate (YYYY-MM-DD):</label>
        <input nz-input [(ngModel)]="searchParams.birthdate" />

        <label>Gender:</label>
        <nz-select [(ngModel)]="searchParams.gender" style="width: 100%">
          <nz-option [nzValue]="''" nzLabel="Any"></nz-option>
          <nz-option [nzValue]="'male'" nzLabel="Male"></nz-option>
          <nz-option [nzValue]="'female'" nzLabel="Female"></nz-option>
          <nz-option [nzValue]="'other'" nzLabel="Other"></nz-option>
          <nz-option [nzValue]="'unknown'" nzLabel="Unknown"></nz-option>
        </nz-select>
      </div>

      <div fxFlex="49" fxLayout="column">
        <label>Address - City:</label>
        <input nz-input [(ngModel)]="searchParams.city" />

        <label>Identifier System:</label>
        <input nz-input [(ngModel)]="searchParams.identifierSystem" />

        <label>Identifier Value:</label>
        <input nz-input [(ngModel)]="searchParams.identifierValue" />
      </div>
    </div>

  </div>
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="">
    <div fxLayout="column" fxFlex="90">
      @if (patientsData.length == 0) {
      <textarea rows="1" nz-input class="text-area-pdq" placeholder="-" [disabled]="true"></textarea>
      }
    </div>
    <div fxLayout="column" fxFlex="10">
      <button nz-button (click)="pdqm()">PDQm</button>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start" class="pdq-container">
    <div fxLayout="column" fxFlex="90">

      @if (patientsData.length > 0) {
      <app-reusable-table [columns]="['Name', 'Gender', 'Birth Date', 'Identifiers', 'Address', 'Link']"
        [rowFields]="['name', 'gender', 'birthDate', 'identifiers', 'address', 'link']" [data]="patientsData"
        [isLoading]="false" [isPreview]="true" [pagination]="false" />
      }


      <!-- <app-reusable-table *ngIf="patientsData.length > 0"
      [columns]="['Name', 'Gender', 'Birth Date', 'Identifiers', 'Address']"
      [rowFields]="['name', 'gender', 'birthDate', 'identifiers', 'address']" [data]="patientsData"
      [isLoading]="false" [isPreview]="true" [pagination]="false" /> -->

    </div>
    <div fxLayout="column" fxFlex="10">
    </div>
  </div>

  @if (nextPageUrl) {
  <button nz-button (click)="loadNextPage()">Next Page</button>
  }
</div>